<template>
  <TheSaib v-if="$store.state.auth.isSignin">
    <template v-slot:buttons>
      <a-button
        class="fl-right"
        style="margin: 5px"
        type="primary"
        shape="round"
        icon="right"
        @click="onApply"
      >다음</a-button>
    </template>
    <div class="fl-right" style="margin-bottom: 20px;">
      <a-input-search placeholder="검색어를 입력하세요." @search="onSearch" />
    </div>
    <table class="list-type-2">
      <thead>
        <tr>
          <td>
            <a-checkbox
              @click="onSelectedAll"
              :indeterminate="$store.state.wholesale.indeterminate"
              :checked="$store.state.wholesale.selectedAll"
            >선택</a-checkbox>
          </td>
          <td>도매 이름</td>
          <td>
            위치
            <br />소속상가 (층/열/호)
          </td>
        </tr>
      </thead>
      <tbody>
        <SaibWholesaleItem
          v-for="(wholesale, index) in $store.state.wholesale.displayed"
          :key="index"
          :idx="wholesale.idx"
          :name="wholesale.name"
          :location="wholesale.location"
        />
      </tbody>
    </table>
  </TheSaib>
</template>
<script>
import TheSaib from "@/components/Saib/TheSaib";
import SaibWholesaleItem from "@/components/Saib/SaibWholesaleItem";
import { TYPES } from "../../stores/wholesale";
import { mapActions } from "vuex";
import config from "../../config";

export default {
  name: "SaibSelector",
  components: { TheSaib, SaibWholesaleItem },
  methods: {
    ...mapActions(["refreshWholesales", "createSaibs", "refreshSaibs"]),
    onSelectedAll() {
      this.$store.commit(TYPES.SWITCH_ALL_WHOLESALES);
    },
    onSearch(value) {
      this.$store.commit(TYPES.WHOLESALE_SEARCH, value);
    },
    onApply() {
      const wholesale = this.$store.state.wholesale;
      if (wholesale.selected.length <= 0) {
        return config.alert.mixin({
          type: "error",
          title: "도매를 1개 이상 선택해주십시오."
        });
      }

      this.createSaibs(wholesale);
      this.$router.push("/saib/apply");
    }
  },
  async mounted() {
    await this.refreshSaibs();
    if (!this.$store.state.saib.canApply) {
      config.alert.mixin({
        type: "warning",
        title: "현재는 사입을 접수할 수 없는 시간입니다."
      });

      this.$router.back();
    }

    this.refreshWholesales();
  }
};
</script>